import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-trusted-partner',
  templateUrl: './trusted-partner.component.html',
  styleUrls: ['./trusted-partner.component.scss']
})
export class TrustedPartnerComponent {
  
@Input() partnerUrl:string|null;
@Input() partnerAlt:string;
@Input() imgSrc:string;

}
